<template>
  <div class="ExamListModal">
    <el-dialog
      title="选择试卷"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
      @close="handleClose"
    >
      <div class="body">
        <div class="leftPart">
          <el-form :model="formData" :rules="rules" size="mini" ref="form1">
            <el-form-item label="自定义系列名称" prop="classSubjectName">
              <el-input
                placeholder="不得超过8个文字"
                v-model="formData.classSubjectName"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="rightPart">
          <div class="tableFilter">
            <el-form :inline="true" :model="filter" size="mini" ref="form">
              <el-form-item label="">
                <el-input
                  style="width: 210px"
                  v-model="filter.keyword"
                  placeholder="试卷名称"
                  @keyup.enter.native="onSubmit"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="onSubmit"
                  >查找
                </el-button>
                <el-button size="mini" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <XTable
            ref="multipleTable"
            :api="getExamList"
            :state="examList"
            :columns="columns"
            :loading="examListLoading"
            :tableSize="tableSize"
            :layout="layout"
            :maxHeight="maxHeight"
            @select="handleSelectionChange"
            @select-all="handleAllChange"
          ></XTable>
        </div>
      </div>
      <div class="footer">
        <el-button
          size="small"
          style="width: 120px"
          type="primary"
          @click="handleConfirm"
          >确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import XTable from "@/components/XTable/index.vue";

export default {
  name: "ExamListModal",
  components: { XTable },
  data() {
    const columns = [
      {
        type: "selection",
        width: 50,
      },
      {
        prop: "name",
        label: "试卷名称",
      },
      /*{
        prop: "classSubjectName",
        label: "分组",
      },*/
      {
        prop: "testQuestionCount",
        label: "试题数",
      },
    ];
    return {
      tableSize: "small",
      layout: " prev, pager, next",
      maxHeight: 455,
      columns: [...columns],
      // 表格选中课程的id数组
      selectLessonIdList: [],
      // 自定义系列名称
      formData: {
        classSubjectName: "",
      },
      rules: {
        classSubjectName: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[\s\S]{0,8}$/,
            message: "不得超过8个文字",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    examList: {
      handler: function (newValue) {
        if (newValue.data) {
          this.$nextTick(() => {
            this.examList.data.forEach((item) => {
              // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
              // toggleRowSelection(item, true)：设置当前行数据为选中状态
              this.selectLessonIdList.forEach((id) => {
                if (item.id === id) {
                  this.$refs.multipleTable.$refs.xTable.$refs.appTable.toggleRowSelection(
                    item,
                    true
                  );
                }
              });
            });
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState("teachingCenter", ["examList", "examListLoading"]),
    visible: {
      get() {
        return this.$store.state.teachingCenter.selectExamModalVisible;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "selectExamModalVisible",
          value,
        });
      },
    },
    filter: {
      get() {
        return this.$store.state.teachingCenter.examListFilter;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "examListFilter",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("teachingCenter", ["setData", "clearFilter"]),
    ...mapActions("teachingCenter", ["saveCustomSubject", "getExamList"]),
    // 选中标签变化
    handleCheck(val, checked) {
      let arr = [];
      if (checked.checkedNodes.length > 0) {
        // 将checkedKeys中的父级id过滤出去
        arr = checked.checkedKeys.filter((id) => {
          return !checked.checkedNodes.some(
            (item) => item.children && item.id === id
          );
        });
      } else {
        arr = checked.checkedKeys;
      }
      this.filter.tagValueIdList = arr;
      this.onSubmit();
    },
    // 单行选中状态
    handleSelectionChange(val, row) {
      if (!this.selectLessonIdList.includes(row.id)) {
        // 回显数据里没有本条，把这条加进来(选中)
        this.selectLessonIdList.push(row.id);
      } else {
        // 回显数据里有本条，把这条删除(取消选中)
        this.selectLessonIdList.forEach((id, index) => {
          if (id === row.id) {
            this.selectLessonIdList.splice(index, 1);
          }
        });
      }
    },
    // 全选反显
    handleAllChange(val) {
      if (val.length > 0) {
        val.forEach((item) => {
          if (!this.selectLessonIdList.includes(item.id)) {
            this.selectLessonIdList.push(item.id);
          }
        });
      } else {
        this.seriesList.data.forEach((item) => {
          this.selectLessonIdList.forEach((id, index) => {
            if (id === item.id) {
              this.selectLessonIdList.splice(index, 1);
            }
          });
        });
      }
    },
    // 打开弹框
    async handleOpen() {
      this.$nextTick(() => {
        this.$refs.form1.clearValidate();
      });
    },
    // 关闭弹框
    handleClose() {
      this.onReset();
      this.clearData();
      this.$refs.multipleTable.$refs.xTable.$refs.appTable.clearSelection();
      this.setData({ key: "examList", value: {} });
    },
    // 查找
    async onSubmit() {
      const filters = {
        ...this.filter,
      };
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getExamList({
            ...filters,
            page: 1,
          });
        }
      });
    },
    // 重置搜索
    async onReset() {
      await this.clearFilter();
      await this.getExamList({
        page: 1,
      });
    },
    // 确认并关闭弹框
    async handleConfirm() {
      await this.$refs.form1.validate(async (valid) => {
        if (valid) {
          if (this.selectLessonIdList.length < 1) {
            this.$message.warning("请选择您要打包的试卷后继续操作!");
            return;
          }
          const res = await this.saveCustomSubject({
            classSubjectName: this.formData.classSubjectName,
            lessonIdList: this.selectLessonIdList,
            type: 2,
          });
          this.$emit("selectedProductCourse", res.data);
          this.$message.success("操作成功");
          await this.clearFilter();
          this.clearData();
          this.$refs.multipleTable.$refs.xTable.$refs.appTable.clearSelection();
          this.setData({ key: "selectExamModalVisible", value: false });
        }
      });
    },
    // 清空弹框数据
    clearData() {
      this.options = [
        {
          value: null,
          label: "全部",
        },
      ];
      this.seriesList = [
        {
          id: null,
          name: "全部",
        },
      ];
      this.selectLessonIdList = [];
      this.formData.classSubjectName = "";
    },
    // 格式化数据
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        if (item.children) {
          newVal[index] = {
            value: item.id,
            label: item.name,
            children: this.formatData(item.children),
          };
        } else {
          newVal[index] = {
            value: item.id,
            label: item.name,
          };
        }
      });
      return newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.ExamListModal {
  ::v-deep .el-dialog {
    min-width: 1030px !important;
  }

  ::v-deep .el-dialog .el-dialog__body {
    padding: 20px 20px;
  }

  .body {
    display: flex;
    justify-content: space-between;
    min-height: 600px;

    .leftPart {
      width: 230px;
      background: #f2f2f2;
      padding: 20px 5px;
      border-radius: 5px;

      ::v-deep .el-tree {
        height: 450px !important;
        //纵向滚动条
        overflow-y: auto;
      }

      .requireStar::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }

    .rightPart {
      width: calc(100% - 250px);
      background: #f2f2f2;
      padding: 10px 20px;
      border-radius: 5px;

      ::v-deep .el-form-item--mini.el-form-item {
        margin-bottom: 10px;
      }

      ::v-deep .appPagination {
        margin-top: 10px;
      }
    }
  }

  .tableFilter {
    padding-bottom: 10px;

    .el-form-item {
      margin-right: 20px;
    }
  }

  ::v-deep .el-pagination {
    text-align: right;
  }

  .footer {
    margin-top: 15px;
    text-align: center;
  }
}
</style>
